"use client";

import { BlockRenderer } from "@litonarefin/components/BlockRenderer";
import React, { Suspense, useRef } from "react";
import { cleanAndTransformBlocks } from "@litonarefin/utils/cleanAndTransformBlocks";
import { getIcon } from "@litonarefin/utils/icons";
import { useReactToPrint } from "react-to-print";
import TableOfContent from "./TableOfContent";
import dynamic from "next/dynamic";

import "@litonarefin/styles/single-docs.scss";

const DocFooter = dynamic(() => import("./DocFooter"));

function DocContent({ singleDoc }) {
  const componentRef = useRef();

  const getPageMargins = () => {
    return `@page { margin: 40px !important; }`;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: getPageMargins,
  });

  return (
    <>
      <button
        className="jlt-absolute jlt-right-10 jlt-top-10 jlt-text-xs jlt-font-semibold jlt-bg-white jlt-text-[#344054] jlt-py-2 jlt-px-4 jlt-rounded jlt-border jlt-border-[#D0D5DD] jlt-flex jlt-items-center jlt-gap-2"
        onClick={() => handlePrint()}
      >
        <span>Print</span>
        {getIcon("print")}
      </button>

      <div ref={componentRef} className="jlt-p-8 xl:jlt-p-10">
        {/* header */}
        <div className="jlt-border-b-[1px] jlt-border-[#EBEEF5] jlt-pb-6 jlt-pr-24">
          <h1
            className="jlt-text-lg md:jlt-text-xl jlt-text-[#16213E] jlt-font-bold jlt-leading-10"
            dangerouslySetInnerHTML={{ __html: singleDoc?.title || "" }}
          />
        </div>
        {/* content  */}
        <div className="jlt-docs-content">
          <BlockRenderer blocks={cleanAndTransformBlocks(singleDoc?.blocks)} />
        </div>
        <Suspense>
          <DocFooter singleDoc={singleDoc} />
        </Suspense>
      </div>

      <div className="jlt-absolute jlt-top-0 jlt-right-[-300px] jlt-h-full">
        <TableOfContent />
      </div>
    </>
  );
}

export default DocContent;
